import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu1"];

  toggle() {
    this.menu1Target.classList.toggle("hidden");
  }

  hide(event) {
    if (!this.element.contains(event.target)) {
      this.menu1Target.classList.add("hidden");
    }
  }
  
}
